import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core'; 
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  API_BASE_PATH = environment.API_URL;

  constructor(private http: HttpClient) { }
  
  sendEmail(userInfoId:string, productInfoId:number, businessEmail: string, name: string, email: string, phone: number, message: string, enquiryPhoto:string ) {
    const data = {
      productInfoId: productInfoId,
      userInfoId: userInfoId,
      businessId: businessEmail,
      name: name,
      email: email,
      phone: phone,
      message: message,
      enquiryPhoto:enquiryPhoto
    };
    return this.http.post(`${this.API_BASE_PATH}enquiry-email`, data);
  }

  // Below API return enquiry list
  fetchEnquiryByUUID(UUID: string) {
    return this.http.get(`${this.API_BASE_PATH}get-enquiry/${UUID}`);
  }

  // Below API return delete enquiry list
  deleteEnquiryByUUID(UUID: string, ID: string) {
    return this.http.delete(`${this.API_BASE_PATH}delete-enquiry/${UUID}/${ID}`);
  }

  sendContactEmail(name: string, email: string, phone: number, address: string, message: string ) {
    return this.http.post(`${this.API_BASE_PATH}contact-enquiry-email`, {name, email, phone, address, message}, {headers: { 'Content-Type': 'application/json' }});
  }

  saveAndEmailPricePlan(userInfoId:string, businessEmail:string, planType:string, paymentId:string, price:string  ) {
    return this.http.post(`${this.API_BASE_PATH}price-plan-email`, {userInfoId, businessEmail, planType, paymentId, price}, {headers: { 'Content-Type': 'application/json' }});
  }
}
